import { multimediaEpaycoUrl } from "../../utils/multimedia";
import { REACT_APP_SECURE, REACT_APP_DEV_UPDATE_FACTURA } from "../../config/env";
import React, {Component} from "react";
import {Flex, Elastic, MyCampo, Mycard, colors, Transition} from "../ui";
import {Btn} from "./../UI-Components/Btn";
import {FooterFactura} from "../pagaFactura";
import styled from "@emotion/styled";
import {Line} from "../pagaFactura";
import {withRouter} from "react-router";
import {useTransition, animated} from 'react-spring';
/** @jsx jsx */
import {jsx, css} from '@emotion/core';
import {b64toBlob, serviceApi, serviceApiResponse, getDataTransactionUrl} from "../ServiciosMaestros/request";
import {lookupTransaction} from "../ServiciosMaestros/transactionLookup";
import {reportRespuestaError} from "../ServiciosMaestros/handleIntegrationError";
import {api} from "../ServiciosMaestros/apis";
import ReactTooltip from "react-tooltip";
import SimpleReactValidator from "simple-react-validator";
import { Mycargando } from './styles'

const Alert = styled.div`
        width:100%;
        height:50px;
        background-color: ${props => colors[props.alert]};
        color:white;
        font-size:25px;
        line-height:50px;
        font-weight:300;
        text-align:center;
        border-radius:4px;
 `;

const ContOverflow = css`
       overflow:hidden;

`;


const ShowEmail = ({email, loading, show, downloadPdf, print, onChangeInputText, sendEmail, loadingEmail, url_respuesta, enviado = false, error = ""}) => {


    const transitions = useTransition(email, null, {
        from: {opacity: 0, transform: email ? "translateX(-100%)" : "translateX(100%)"},
        enter: {opacity: 1, transform: "translateX(0)"},
        leave: {opacity: 0, position: "absolute", transform: email ? "translateX(100%)" : "translateX(-100%)"},
    })

    return (

        transitions.map(({item, key, props}) =>
            item
                ?
                <animated.div style={props} className="col-12  pl-md-0">
                    <Flex alg={"flex-end"}>
                        <div className="col-12 col-sm-6 px-0 ">
                            <MyCampo
                                type={"text"}
                                name={"textEmail"}
                                label={enviado ? "¡Correo enviado exitosamente! " : "Enviar una copia al email"}
                                disabled={loadingEmail}
                                placeholder={"Ingrese su email"}
                                onchange={(e) => onChangeInputText(e)}
                                enviado={enviado}
                                error={error}
                            />
                        </div>
                        <div className="col-12 col-sm-3 px-0 pt-3 pt-sm-0 pl-sm-2 pr-sm-3 line-height-0"
                             onClick={() => sendEmail()}>
                            <Btn bg hg={"45"}
                                 loading={loadingEmail}
                                 disabled={loadingEmail}

                            >Enviar</Btn>
                        </div>
                        <div className="col-12 col-sm-3 px-0 pt-3 pt-sm-0">
                            <Btn bg hg={"45"} onClick={show}>Otras opciones</Btn>
                        </div>
                    </Flex>
                </animated.div> :

                <animated.div style={props} className="col-12 px-0 pt-26">
                    <Flex className={"col-12 px-0"}>
                        <div className={url_respuesta.activo ? "col-12 col-md-6 pb-3 pb-md-0 pl-md-0 btn-bar-font" :"col-12 col-md-5 pb-3 pb-md-0 pl-md-0"}>
                            <Btn classNameBtn="btn-vertical-aln" bg hg={"45"} onClick={show}>
                                <img src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/envelope.png")}
                                     alt="" width={"20px"} height={"auto"} className={"mr-2"}/>
                                Enviar copia por correo
                            </Btn>
                        </div>
                        <Flex className={url_respuesta.activo ? "col-12 col-md-6 pl-md-0 btn-bar-font" : "col-12 col-md-7 pl-md-0 "}>
                            <div className="col-12 col-sm-6 pb-3 pb-sm-0 px-0 pr-sm-2" onClick={() => print()}>
                                <Btn classNameBtn="btn-vertical-aln" bg hg={"45"}><img
                                    src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/print.png")}
                                    alt="" className={"mr-2"}/>Imprimir</Btn>
                            </div>
                            <div className={url_respuesta.activo ? "col-12 col-sm-6 px-0 pl-sm-2 btn-bar-font" : "col-12 col-sm-6 px-0 pl-sm-2"} onClick={() => downloadPdf()}>
                                <Btn classNameBtn="btn-vertical-aln" bg hg={"45"}
                                     disabled={loading}
                                     loading={loading}
                                >
                                    <img
                                        src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/download.png")}
                                        alt=""
                                        className={`mr-2`}/>Descargar
                                </Btn>
                            </div>
                        </Flex>
                    </Flex>
                </animated.div>)

    )
}

let ruta = {};

class RespuestaOnline extends Component {

    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator(
            {
                messages: {
                    required: "Debe ingresar un :attribute",
                    regex: "Debe ingresar una dirección de :attribute válida",
                },
            }
        )
        let generarCodigoPago = JSON.parse(sessionStorage.getItem("opcionesRecaudo"));
        const url_respuesta = JSON.parse(sessionStorage.getItem("configuracion")).url_respuesta;

        if(generarCodigoPago["generarCodigoPago"] && generarCodigoPago["generarCodigoPago"]["activo"]){
            generarCodigoPago = true;
        }else{
            generarCodigoPago = false;
        }
        this.state = {
            loading: false,
            loadingEmail: false,
            informacionEmpresa: {},
            response: {},
            email: false,
            textEmail: "",
            errorPago: false,
            integrationErrorMessage: "",
            loadingTransaction: true,
            printState: false,
    
            infoFactura: [],
            infoCabecera: {},
            infoEmpresa: {},
            total: 0,
            iva: 0,
            moneda: "COP",
            enviado: false,
            param: {
                option: "",
                referencia: "",
            },
            facturas: [],
            abonos:[],
            opcionPago:[],
            generarCodigoPago,
            cargandoCodigoPago: true,
            facturasDetalle: [],
            url_respuesta:{
                ...{
                    activo:false,
                },
                ...url_respuesta
            }
        };
        this.FormatoCampo = this.FormatoCampo.bind(this);
        this.loadTransaction = this.loadTransaction.bind(this);
    }

    componentWillMount() {
        ruta = JSON.parse(sessionStorage.getItem("rutas"));
    }

    FormatoCampo(Inf){
        let valor = "";
        switch (Inf.tipo_campo_2) {
            case 'moneda':
                valor = `$ ${parseFloat(Inf.valor).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                })} ${Inf.moneda}`;
                break;
            case 'numerico':
                valor = parseFloat(Inf.valor).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                });
                break;
            case 'porcentaje':
                valor = `${parseFloat(Inf.valor).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                })} %`;
                break;
            default:
                valor = Inf.valor
                break;
        }
        return valor;
    }
    verData(facturas,respuesta){
        let configCampos2 = JSON.parse(sessionStorage.getItem("configCampos"));
        let facturasCopy=[...facturas];
        let key = sessionStorage.getItem("facturaPagar") ? JSON.parse(sessionStorage.getItem("facturaPagar")) : [0];
        if (facturas && facturas.length > 0) {
            let entidadValor="";
            let entidadIva="";
            let posicionIva=[];
            let idCheckout="";
            let valorCheckout="";
            let check=[];
            let checksOtroValor=[];
            let checksValor1=[];
            let checksValor2=[];
            let checksValor3=[];
            let valuesOtroValor=[];
            let posicionInfo=0;
            let session=false;
            let visibleIva=false;
            let ivaCalculado=false;
            let valorCalculado=false;

            let abonos=[];
            let opcionPago=[];

            let total = 0;
            let iva = 0;
            let iva1 = 0;
            let moneda = "";
            if(typeof key ==="number"){
                key=[key];
            }
            let opcionesRecaudo=sessionStorage.getItem("opcionesRecaudo")?JSON.parse(sessionStorage.getItem("opcionesRecaudo")):{};
            let param=JSON.parse(sessionStorage.getItem("param"));

            let fact=[];
            key.forEach((ks)=>{
                fact.push(facturas[ks]);
            });
            let aux=false;
            let infoCabecera = {
                titulo: "Pagos Online",
                valor: "",
                referencia: "Pagos Online",
                option: "Pagos Online",
    
            };
            let infoFactura =[];
            if(sessionStorage.getItem("check")) {
                check = JSON.parse(sessionStorage.getItem("check"));
                checksOtroValor = JSON.parse(sessionStorage.getItem("checksOtroValor"));
                checksValor1 = JSON.parse(sessionStorage.getItem("checksValor1"));
                checksValor2 = JSON.parse(sessionStorage.getItem("checksValor2"));
                checksValor3 = JSON.parse(sessionStorage.getItem("checksValor3"));
                valuesOtroValor = JSON.parse(sessionStorage.getItem("valuesOtroValor"));
                check.forEach((c) => {
                    if (c) session = true;
                })

                checksOtroValor.forEach((c)=>{
                    if(c)session=true;
                })

                checksValor1.forEach((c)=>{
                    if(c)session=true;
                })

                checksValor2.forEach((c)=>{
                    if(c)session=true;
                })

                checksValor3.forEach((c)=>{
                    if(c)session=true;
                })
            }
            
            let abonosCargados = false;
            
            if(sessionStorage.getItem("abonos_factura")) {
                let abonosFromFactura = JSON.parse(sessionStorage.getItem("abonos_factura"));
                let opcionPagoFromFactura = JSON.parse(sessionStorage.getItem("opcionPago_factura"));
                
            
                abonos = abonosFromFactura;
                opcionPago = opcionPagoFromFactura;
                abonosCargados = true;
                
                if(abonos.some(a => a !== null && a > 0)) {
                    session = true;
                }
                
            }
            
            const facturasDetalle = this.state.facturasDetalle;
            const generarCodigoPago = this.state.generarCodigoPago;
            let configCampos = [];
            if(generarCodigoPago){
                configCampos.push({
                    "idForm": "respuesta0",
                    "option": 0,
                    "nombreParametro": "id",
                    "visible": true,
                    "configCampo": "texto",
                    "tipoCampo": "codigo_pago",
                    "campoDb": "codigo_pago",
                    "textoAyuda": "",
                    "formValid": true,
                    "nombreCampo": facturasDetalle[0].titulo_codigo_pago == "" ? "Código de pago" : facturasDetalle[0].titulo_codigo_pago
                })
                for (let index = 0; index < configCampos2.length; index++) {
                    configCampos.push(configCampos2[index])
                }
                for (let index = 0; index < fact.length; index++) {
                    for (let index2 = 0; index2 < facturasDetalle.length; index2++) {
                        if(fact[index].id == facturasDetalle[index2].id){
                            fact[index]["codigo_pago"] = facturasDetalle[index2]["codigo_pago"];
                        }
                    }
                }
            }else{
                configCampos = configCampos2;
            }
            // console.log(fact.length)
            configCampos.map((conf, kconf) => {
                let keysOfDirefentData=[];
                // console.log(fact.length)
                if(fact.length>1){
                    Object.keys(fact[0]).forEach((f,fk) => {
                        fact.forEach((fac,index)=>{
                            if(index!==0){
                                if(keysOfDirefentData.length===0 || !keysOfDirefentData.includes(fk)){
                                    if(fact[0][f]!==fac[f]){
                                        keysOfDirefentData.push(f);
                                    }
                                }
                            }
                        })
                    });
                    let data = {};
                    Object.keys(fact[0]).forEach((k,objectKey) => {
                        if ((k === conf.tipoCampo && conf.visible && !keysOfDirefentData.includes(k))) {

                            data["titulo"] = conf.nombreCampo;
                            data["ayuda"] = conf.texto_ayuda;
                            data["tipo_campo_2"] = conf.tipo_campo_2;
                            data["moneda"] = fact[0]["moneda"];
                            if (k === conf.tipoCampo && (conf.tipoCampo.search("valor") !== -1 || conf.tipoCampo.search("total") !== -1 || conf.tipoCampo.search("segundoTotal") !== -1) || conf.tipoCampo.search("tercerTotal") !== -1) {
                                entidadValor=k;
                                key.forEach((v,vkey)=>{
                                    if(session){
                                        if(checksValor1[v]){
                                            if(!abonosCargados) {
                                                opcionPago.push("total");
                                                abonos.push(null);
                                            }
                                            facturas[v][k]=fact[vkey][k];
                                            total+= fact[vkey][k];
                                            valorCheckout+=`${String(fact[vkey][k])}${vkey===key.length-1?"":":"}`;
                                            // data["valor"] = `$ ${parseFloat(fact[vkey][k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[vkey]["moneda"]}`;
                                        }

                                        if(checksValor2[key[0]]){
                                            if(!abonosCargados) {
                                                abonos.push(null);
                                                opcionPago.push("segundoTotal");
                                            }
                                        }

                                        if(checksValor3[key[0]]){
                                            if(!abonosCargados) {
                                                abonos.push(null);
                                                opcionPago.push("tercerTotal");
                                            }
                                        }

                                        if(checksOtroValor[v] && !aux){
                                            if(!abonosCargados) {
                                                abonos.push(valuesOtroValor[v]);
                                                opcionPago.push("abono");
                                            }
                                            aux=true;
                                            facturas[v][k]=valuesOtroValor[v];
                                            total+= valuesOtroValor[v];
                                            valorCheckout+=`${String(valuesOtroValor[v])}${vkey===key.length-1?"":":"}`;
                                            // data["valor"] = `$ ${parseFloat(valuesOtroValor[v]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[vkey]["moneda"]}`;
                                        }
                                    }else{
                                        if(!abonosCargados) {
                                            abonos.push(null);
                                            opcionPago.push(k);
                                        }
                                        total += fact[vkey][k];
                                        valorCheckout+=`${String(fact[vkey][k])}${vkey===key.length-1?"":":"}`;
                                        // data["valor"] = `$ ${parseFloat(fact[vkey][k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[vkey]["moneda"]}`;
                                    }
                                });
                                data["valor"] = `$${parseFloat(total).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[0]["moneda"]}`;
                                // console.log(data)
                                // total += fact[0][k];
                                moneda = fact[0]["moneda"];
                            }else if(k === conf.tipoCampo && (conf.tipoCampo==="iva" || conf.tipoCampo==="segundoIva" || conf.tipoCampo==="tercerIva")){
                                entidadIva=k;
                                visibleIva=true
                                // console.log(conf.tipoCampo,conf.tipoCampo.search("iva") !== -1)
                                key.forEach((v,vkey)=>{
                                    if(session){
                                        if(checksValor1[v] && k==="iva"){
                                            // let valorDelIva=fact[kn][entidadValor];
                                            iva1 += fact[vkey][k];
                                            facturas[v][k]=fact[vkey][k];
                                        }
                                        if(checksValor2[v] && k==="segundoIva"){
                                            // let valorDelIva=fact[kn][entidadValor];
                                            iva1 += fact[vkey][k];
                                            facturas[v][k]=fact[vkey][k];
                                        }
                                        if(checksValor3[v] && k==="tercerIva"){
                                            // let valorDelIva=fact[kn][entidadValor];
                                            iva1 += fact[vkey][k];
                                            facturas[v][k]=fact[vkey][k];
                                        }

                                        if(checksOtroValor[v]){
                                            if(valorCalculado){
                                                let valorDelIva=(fact[vkey][k]/fact[vkey][entidadValor])*valuesOtroValor[v];
                                                iva1+= valorDelIva;
                                                facturas[v][k]=valorDelIva;
                                            }else{
                                                ivaCalculado=true;
                                                posicionIva.push(vkey);
                                            }

                                        }
                                    }else{
                                        iva1 += fact[vkey][k];
                                    }
                                });
                                // console.log(iva1, k);
                                data["valor"] = `$${parseFloat(iva1).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[0]["moneda"]}`;
                                iva = iva1;
                            } else if(k === conf.tipoCampo){
                                // console.log(data,fact[0][k],k)
                                data["valor"] = fact[0][k];
                            }
                            // console.log(data)
                            // if (conf.tipoCampo === "facturaId") {
                            //     infoCabecera = data;
                            // }

                            // if(Object.keys(opcionesRecaudo).length>0 && opcionesRecaudo.generarNumeroFactura.activo){
                            //     infoCabecera = {titulo:param.option,valor:param.referencia};
                            // }
                        }else if((k === conf.tipoCampo && (conf.tipoCampo==="total" || conf.tipoCampo==="iva" || conf.tipoCampo.search("segundoTotal") !== -1) || conf.tipoCampo.search("tercerTotal") !== -1)){
                            if (k === conf.tipoCampo && (conf.tipoCampo.search("valor") !== -1 || conf.tipoCampo.search("total") !== -1 || conf.tipoCampo.search("segundoTotal") !== -1) || conf.tipoCampo.search("tercerTotal") !== -1) {
                                entidadValor=k;

                                key.forEach((v,vkey)=>{
                                    // console.log("key",key,k)
                                    if(session){
                                        if(checksValor1[v]){
                                            opcionPago.push("total");
                                            abonos.push(null);
                                            facturas[v][k]=fact[vkey][k];
                                            total+= fact[vkey][k];
                                            valorCheckout+=`${String(fact[vkey][k])}${vkey===key.length-1?"":":"}`;
                                            // data["valor"] = `$ ${parseFloat(fact[vkey][k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[vkey]["moneda"]}`;
                                        }

                                        if(checksValor2[key[0]]){
                                            abonos.push(null);
                                            opcionPago.push("segundoTotal");
                                        }

                                        if(checksValor3[key[0]]){
                                            abonos.push(null);
                                            opcionPago.push("tercerTotal");
                                        }

                                        if(checksOtroValor[v] && !aux){
                                            abonos.push(valuesOtroValor[v]);
                                            opcionPago.push("abono");
                                            aux=true;
                                            facturas[v][k]=valuesOtroValor[v];
                                            total+= valuesOtroValor[v];
                                            valorCheckout+=`${String(valuesOtroValor[v])}${vkey===key.length-1?"":":"}`;
                                            // data["valor"] = `$ ${parseFloat(valuesOtroValor[v]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[vkey]["moneda"]}`;
                                        }
                                    }else{
                                        abonos.push(null);
                                        opcionPago.push(k);
                                        total += fact[vkey][k];
                                        valorCheckout+=`${String(fact[vkey][k])}${vkey===key.length-1?"":":"}`;
                                        // data["valor"] = `$ ${parseFloat(fact[vkey][k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[vkey]["moneda"]}`;
                                    }
                                });

                                // total += fact[0][k];
                                moneda = fact[0]["moneda"];
                            }else if(k === conf.tipoCampo && (conf.tipoCampo==="iva"  || conf.tipoCampo==="segundoIva" || conf.tipoCampo==="tercerIva")){
                                entidadIva=k;
                                visibleIva=true;
                                // console.log(conf.tipoCampo,conf.tipoCampo.search("iva") !== -1)
                                key.forEach((v,vkey)=>{
                                    if(session){
                                        if(checksValor1[v] && k==="iva"){
                                            // let valorDelIva=fact[kn][entidadValor];
                                            iva1 += fact[vkey][k];
                                            facturas[v][k]=fact[vkey][k];
                                        }
                                        if(checksValor2[v] && k==="segundoIva"){
                                            // let valorDelIva=fact[kn][entidadValor];
                                            iva1 += fact[vkey][k];
                                            facturas[v][k]=fact[vkey][k];
                                        }
                                        if(checksValor3[v] && k==="tercerIva"){
                                            // let valorDelIva=fact[kn][entidadValor];
                                            iva1 += fact[vkey][k];
                                            facturas[v][k]=fact[vkey][k];
                                        }

                                        if(checksOtroValor[v]){
                                            if(valorCalculado){
                                                let valorDelIva=(fact[vkey][k]/fact[vkey][entidadValor])*valuesOtroValor[v];
                                                iva1+= valorDelIva;
                                                facturas[v][k]=valorDelIva;
                                            }else{
                                                ivaCalculado=true;
                                                posicionIva.push(vkey);
                                            }

                                        }
                                    }else{
                                        iva1 += fact[vkey][k];
                                    }
                                });
                                // console.log(iva1, k);
                                iva = iva1;
                            }

                            // if (conf.tipoCampo === "facturaId") {
                            //
                            //     infoCabecera = data;
                            // }

                            // if(Object.keys(opcionesRecaudo).length>0 && opcionesRecaudo.generarNumeroFactura.activo){
                            //     infoCabecera = {titulo:param.option,valor:param.referencia};
                            // }
                        }
                    });
                    if(Object.keys(data).length>0){
                        infoFactura.push(data);
                    }


                    if(kconf===0){
                        infoFactura.unshift({"titulo":"Número de facturas seleccionadas","ayuda":"","valor":key.length})

                    }

                }
                else {
                    fact.forEach((fac,i)=>{
                        let data = {};
                        Object.keys(fac).forEach((k,objK) => {
                            if (k === conf.tipoCampo && conf.visible) {
                                data["titulo"] = conf.nombreCampo;
                                data["ayuda"] = conf.texto_ayuda;
                                data["tipo_campo_2"] = conf.tipo_campo_2;
                                data["moneda"] = fact[0]["moneda"];
                                if (conf.tipoCampo.search("valor") !== -1 || conf.tipoCampo.search("total") !== -1  || conf.tipoCampo.search("segundoTotal") !== -1 || conf.tipoCampo.search("tercerTotal") !== -1) {
                                    entidadValor=k;
                                    valorCalculado=true;
                                    idCheckout+=`${String(fact[i]["id"])}${i===fact.length-1?"":":"}`;
                                    data["valor"] = `$ ${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fac["moneda"]}`;
                                    if(session){
                                        if(checksValor1[key[0]] && k==="total"){
                                            abonos.push(null);
                                            opcionPago.push(k);
                                            facturas[key[0]][k]=fac[k];
                                            total+= fac[k];
                                            valorCheckout+=`${String(fac[k])}${i===fact.length-1?"":":"}`;
                                            data["valor"] = `$ ${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fac["moneda"]}`;
                                        }

                                        if(checksValor2[key[0]] && k==="segundoTotal"){
                                            abonos.push(null);
                                            opcionPago.push(k);
                                        }

                                        if(checksValor3[key[0]] && k==="tercerTotal"){
                                            abonos.push(null);
                                            opcionPago.push(k);
                                        }

                                        if(checksOtroValor[key[0]] && !aux){
                                            abonos.push(valuesOtroValor[key[0]]);
                                            opcionPago.push("abono");
                                            facturas[key[0]][k]=valuesOtroValor[key[0]];
                                            total+= valuesOtroValor[key[0]];
                                            valorCheckout+=`${String(valuesOtroValor[key[0]])}${i===fact.length-1?"":":"}`;
                                        }
                                    }else{
                                        if(Object.keys(opcionesRecaudo).length>0 && opcionesRecaudo.multiplesValoresPago.activo){
                                            if(!isNaN(fac[k])){
                                                if(this.state.response.x_amount===fac[k]){
                                                    abonos.push(null);
                                                    opcionPago.push(k)
                                                }else if(opcionesRecaudo.modificarValorPagar.activo){
                                                    if(objK===Object.keys(fac).length-1 && abonos.length<=0){
                                                        abonos.push(this.state.response.x_amount);
                                                        opcionPago.push("abono")
                                                    }
                                                }
                                            }
                                        }else {
                                            abonos.push(null);
                                            opcionPago.push(k);
                                        }
                                        total += fac[k];
                                        valorCheckout+=`${String(fac[k])}${i===fact.length-1?"":":"}`;
                                        data["valor"] = `$ ${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fac["moneda"]}`;
                                    }
                                    moneda = fac["moneda"];
                                }else if(conf.tipoCampo=== "iva"  || conf.tipoCampo=== "segundoIva" || conf.tipoCampo === "tercerIva"){
                                    visibleIva=true;
                                    data["valor"] = `$ ${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fac["moneda"]}`;
                                    if(session){
                                        if(checksValor1[i] && k==="iva"){
                                            iva += fac[k];
                                            facturas[key[0]][k]=fac[k];
                                        }

                                        if(checksValor2[i] && k==="segundoIva"){
                                            iva += fac[k];
                                            facturas[key[0]][k]=fac[k];
                                        }

                                        if(checksValor3[i] && k==="tercerIva"){
                                            iva += fac[k];
                                            facturas[key[0]][k]=fac[k];
                                        }

                                        if(checksOtroValor[i]){
                                            if(valorCalculado){
                                                let valorDelIva=(fact[i][k]/fact[i][entidadValor])*valuesOtroValor[i];
                                                iva1+= valorDelIva;
                                                facturas[key[0]][k]=valorDelIva;
                                            }else{

                                                ivaCalculado=true;
                                                posicionIva.push(0);
                                            }

                                        }
                                    }else{
                                        iva += fac[k];
                                    }
                                } else {
                                    data["valor"] = fac[k];
                                }
                            }
                            else if(k === conf.tipoCampo) {
                                visibleIva=false;
                                if(conf.tipoCampo.search("iva") !== -1 ){
                                    entidadIva=k;
                                    posicionInfo=objK;

                                    if(session){
                                        if(checksValor1[i]){
                                            iva += fac[k];
                                            facturas[key[0]][k]=fac[k];
                                        }

                                        if(checksOtroValor[i]){
                                            if(valorCalculado){
                                                let valorDelIva=(fact[i][k]/fact[i][entidadValor])*valuesOtroValor[i];
                                                iva1+= valorDelIva;
                                                facturas[key[0]][k]=valorDelIva;
                                            }else{

                                                ivaCalculado=true;
                                                posicionIva.push(0);
                                            }

                                        }
                                    }else{
                                        iva += fac[k];
                                    }
                                }
                            }
                        });
                        if(Object.keys(data).length>0){
                            infoFactura.push(data);
                        }

                        if(kconf===0){
                            infoFactura.unshift({"titulo":"Número de facturas seleccionadas","ayuda":"","valor":key.length})
                        }

                    })
                }
            });
            if(entidadIva !== "" && entidadValor !== ""){
                posicionIva.forEach((p)=>{
                    let valorDelIva=(fact[p][entidadIva]/facturasCopy[key[p]][entidadValor])*valuesOtroValor[key[p]];
                    iva+= valorDelIva;
                    facturas[p][entidadIva]=valorDelIva;
                });
                if(visibleIva && ivaCalculado){
                    infoFactura[(posicionInfo+1)]["valor"]=`$ ${parseFloat(iva).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[0]["moneda"]}`
                }
            }

            if(fact.length>1){
                infoFactura.push({"titulo":"Valor final ","ayuda":"","valor":`$ ${parseFloat(this.state.response.x_amount).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fact[0]["moneda"]}`})
            }

            this.setState({
                infoFactura,
                infoCabecera,
                total,
                moneda,
                iva,
                param: JSON.parse(sessionStorage.getItem("param")),
                facturas:key.length>1?facturas:[facturas[key[0]]],
                abonos,
                opcionPago
            })
        }else {
            this.props.openModal("Factura no encontrada.", "danger")
            this.props.history.push(ruta.home);
        }

    }

    loadTransaction() {
        let informacionEmpresa = JSON.parse(sessionStorage.getItem("informacion"));
        let facturas = JSON.parse(sessionStorage.getItem("facturas"));
        let ref_payco = this.getQueryParam('ref_payco');

        this.setState({
            loadingTransaction: true,
            integrationErrorMessage: "",
        });

        lookupTransaction(ref_payco)
            .then(response => {
                if (response.success) {
                    let respuesta = response.data;
                    const generarCodigoPago = this.state.generarCodigoPago && respuesta.x_transaction_state == "Aceptada";
                    this.setState({
                        informacionEmpresa,
                        response: response.data,
                        generarCodigoPago,
                        loadingTransaction: false,
                        errorPago: false,
                        integrationErrorMessage: "",
                    }, () => {
                        if(generarCodigoPago){
                            this.verDetalles(respuesta.x_ref_payco, () => {
                                this.verData(facturas, respuesta)
                            });
                        }else{
                            this.verData(facturas, respuesta);
                        }
                    });
                } else {
                    this.setState({
                        informacionEmpresa,
                        errorPago: true,
                        integrationErrorMessage: "",
                        loadingTransaction: false,
                        response: {
                            x_cod_response: 4,
                            x_transaction_state: "Cancelado"
                        }
                    });
                }
            }).catch(error => {
                reportRespuestaError(this, error, {
                    refPayco: ref_payco,
                    endpoint: `${REACT_APP_SECURE}/${ref_payco}`,
                    statePatch: {
                        informacionEmpresa,
                        response: {
                            x_cod_response: 4,
                            x_transaction_state: "No disponible"
                        },
                    },
                });
            });
    }

    componentDidMount() {
        this.loadTransaction();
    }
    verDetalles(respuesta, next){
        serviceApiResponse({
            "referencia": respuesta,
            "tipoProyecto": JSON.parse(sessionStorage.getItem("configuracion"))["tipo"]
        }, api.codigoPagoConsulta, "POST")
            .then(response => {
                this.setState({
                    facturasDetalle: JSON.parse(response.data),
                    cargandoCodigoPago: false
                }, () => {
                    next();
                })
                
            })
            .catch(error => {
                reportRespuestaError(this, error, {
                    showModal: true,
                    endpoint: api.codigoPagoConsulta,
                    service: "recaudo-api",
                    setComponentState: false,
                });
                this.setState({cargandoCodigoPago: false});
                if (typeof next === "function") {
                    next();
                }
            })
    }
    updateFactura(facturas, respuesta,key) {
        let explodeFacturas=this.state.response.x_extra10.split(":");
        let facturasPagas=[];
        let aux=0;
        let key2="";
        explodeFacturas.forEach((factura)=>{
            if(!isNaN(factura)){
                if(facturasPagas[aux]){
                    if(facturasPagas[aux][key2]){
                        aux++;
                        if(facturasPagas[aux]!==undefined){
                            facturasPagas[aux][key2]=parseFloat(factura);
                        }else{
                            facturasPagas.push({[key2]:parseFloat(factura)});
                        }
                    }else{
                        facturasPagas[aux][key2]=parseFloat(factura);
                    }
                }
                else facturasPagas.push({[key2]:parseFloat(factura)});
            }else{
                aux=0;
                key2=factura;
            }
        });



        serviceApiResponse({
            param: JSON.parse(sessionStorage.getItem("param")),
            informacion: JSON.parse(sessionStorage.getItem("informacion")),
            busqueda: JSON.parse(sessionStorage.getItem("configCampos")),
            facturas2: JSON.parse(sessionStorage.getItem("facturas")),
            fechaFactura: JSON.parse(sessionStorage.getItem("fechaActualizacion")),
            total: this.state.total,
            abonos:this.state.abonos,
            opcionPago:this.state.opcionPago,
            transaccion: this.state.response,
            respuesta: this.state.response.x_cod_response,
            facturaPagar: sessionStorage.getItem("facturaPagar") ? JSON.parse(sessionStorage.getItem("facturaPagar")) : [0],
            ref_payco: respuesta.x_ref_payco,
            dev: REACT_APP_DEV_UPDATE_FACTURA === "true",
            facturas: facturasPagas,
        }, api.aplicarPago, "POST")
            .then(response => {
                // console.log(response);
            })
            .catch(error => {
                // console.log(error);
            })
    }

    downloadPdf() {
        sessionStorage.getItem("param");

        const data = {
            param: JSON.parse(sessionStorage.getItem("param")),
            informacion: JSON.parse(sessionStorage.getItem("informacion")),
            busqueda: JSON.parse(sessionStorage.getItem("configCampos")),
            facturas: this.updateInvoiceValue(JSON.parse(sessionStorage.getItem("facturas")), this.state.response),
            fechaFactura: JSON.parse(sessionStorage.getItem("fechaActualizacion")),
            total: this.state.total,
            abonos:this.state.abonos,
            opcionPago:this.state.opcionPago,
            transaccion: this.state.response,
            respuesta: this.state.response.x_cod_response,
            facturaPagar: sessionStorage.getItem("facturaPagar") ? JSON.parse(sessionStorage.getItem("facturaPagar")) : [0],
            facturasDetalle: this.state.facturasDetalle
        };

        this.setState({loading: true});
        serviceApiResponse(data, `${api.exportar}`, "POST")
            .then(response => {
                if (response.success) {
                    const contentType = response.data.contentType;
                    const b64Data = response.data.ruta;

                    const blob = b64toBlob(b64Data, contentType);
                    const blobUrl = URL.createObjectURL(blob);

                    let element = document.getElementById('pdf');
                    element.setAttribute('href', blobUrl);
                    element.setAttribute('download', response.data.nombre);
                    element.click();
                }
                this.setState({loading: false});
            })
            .catch(error => {
                reportRespuestaError(this, error, {
                    showModal: true,
                    endpoint: api.exportar,
                    service: "recaudo-api",
                    setComponentState: false,
                });
                this.setState({loading: false});
            });
    }

    verificarEstadoTransaccion(estado) {
        if (estado === 1) {
            return "alertG";
        } else if (estado === 2) {
            return "alertR"
        } else if (estado === 3) {
            return "alertY"
        } else if (estado === 4) {
            return "alertR"
        }
    }


    getQueryParam(param) {
        window.location.search.substr(1)
            .split("&")
            .some(function (item) { // returns first occurence and stops
                return item.split("=")[0] == param && (param = item.split("=")[1])
            })
        return param
    }

    print() {
        this.setState({printState: true}, () => {
            window.print();
            setTimeout(
                () => {
                    this.setState({printState: false});
                },
                100
            );
        });
    }

    sendEmail() {
        const {response, textEmail} = this.state;
        if (this.validator.allValid()) {
            this.setState({loadingEmail: true});
            serviceApi({}, getDataTransactionUrl() + `?transaction_id=${response.x_ref_payco}&email_adicional=${textEmail}`, 'POST')
                .then(result => {
                    if (result.success === "ok") {
                        this.setState({enviado: true}, () => {
                            setTimeout(() => {
                                this.setState({enviado: false})
                            }, 10000)
                        });
                        // this.messageToast("Correo enviado exitosamente", "success");
                    } else {
                        // this.messageToast("No se pudo enviar el correo electrónico", "error");
                    }
                    this.setState({loadingEmail: false});
                })
                .catch(error => {
                    reportRespuestaError(this, error, {
                        showModal: true,
                        endpoint: "email/transaccion",
                        service: "recaudo-api",
                        setComponentState: false,
                    });
                    this.setState({loadingEmail: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    onChangeInputText(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState({
            [name]: value,
        })
    }
    validateStatus(){
        switch(this.state.response.x_transaction_state){
            case 'Aceptada':
                return 'Aceptado'
                break;
            case 'Rechazada':
                return 'Rechazado'
                break;
            case 'Fallida':
                return 'Fallido'
                break;
            case 'Reversada':
                return 'Reversado'
                break;
            case 'Retenida':
                return 'Retenido'
                break;
            case 'Iniciada':
                return 'Iniciado'
                break;
            case 'Exprirada':
                return 'Expirado'
                break;
            case 'Abandonada':
                return 'Abandonado'
                break;
            case 'Cancelada':
                return 'Cancelado'
                break;
            default:
                return this.state.response.x_transaction_state
                break;
        }
    }
    updateInvoiceValue(factura, tr){
        try {
            if(!tr.hasOwnProperty('x_amount')){
              return factura;
            }
            if(factura.length == 0){
                factura[0].total = tr.x_amount
                return factura;
            }
            return factura;
        } catch (error) {
            return factura;
        }
    }
    render() {

        return (
            <Elastic felx={"1 0 auto"}
                     className={"wc cambio"}
                     css={css`animation:  ${Transition}  .8s cubic-bezier(0.075, 0.820, 0.165, 1.000) 1;`}

            >
                <Mycard
                    title={`${!this.state.errorPago ? `Pagos Online` : ""}`}
                    // back={"/facturas"}
                    className={" col-12 col-lg-10 mx-auto px-0"}
                    footer={this.state.informacionEmpresa.mostrarDatos == 1 && <FooterFactura info={this.state.informacionEmpresa}/>}
                    history={this.props.history}


                >
                    { this.state.cargandoCodigoPago  && this.state.generarCodigoPago ? 
                        (<Mycargando loading={this.state.cargandoCodigoPago && this.state.generarCodigoPago}/>)
                    : 
                    <div className="wc px-lg-4 px-md-3 ">

                        <div className="col-12">
                            <Alert alert={this.verificarEstadoTransaccion(this.state.response.x_cod_response)}
                                   className={"mb-3"}>
                                {`Pago ${this.validateStatus()}`}
                            </Alert>
                            {this.state.integrationErrorMessage && (
                                <div className="col-12 mb-3 text-center">
                                    <p className="cg mb-3">{this.state.integrationErrorMessage}</p>
                                    <Btn bg hg={"45"} onClick={this.loadTransaction}>
                                        Reintentar consulta
                                    </Btn>
                                </div>
                            )}
                        </div>
                        {!this.state.errorPago && (
                            <Flex className={"wc pb-3 align-items-start"}
                            >
                                <div className="col-12 col-md-6 pl-md-0 ">
                                    <p className={"cg mb-0"}>Detalle del comprobante</p>

                                    {this.state.infoFactura.map((inf, key) => (
                                        <Flex>
                                            <ReactTooltip id={`help-${key}`} place="right" type="info" effect="solid">
                                                {inf.ayuda}
                                            </ReactTooltip>
                                            <div className="col-6 pl-0 cg c0">
                                                <small data-tip data-for={`help-${key}`}><b>{inf.titulo}</b></small>
                                            </div>
                                            <div className="col-6 pr-0 cg text-right">
                                                <small>{this.FormatoCampo(inf)}</small>
                                            </div>
                                            <Line dotted/>
                                        </Flex>
                                    ))}
                                </div>
                                <div className="col-12 col-md-6 pr-md-0 pt-4 pt-md-0 ">
                                    <p className={"cg mb-0"}>Detalle de la transacción</p>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Referencia</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_id_invoice}</small>
                                        </div>
                                        <Line dotted/>
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Referencia ePayco</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_ref_payco}</small>
                                        </div>
                                        <Line dotted/>
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>IP origen</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_customer_ip}
                                            </small>
                                        </div>
                                        <Line dotted/>
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Método de pago</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_franchise}
                                                - {this.state.response.x_cardnumber}</small>
                                        </div>
                                        <Line dotted/>
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Número de recibo</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_id_invoice}</small>
                                        </div>
                                        <Line dotted/>
                                    </Flex>
                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Total pagado</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>$ {parseFloat(this.state.response.x_amount).toLocaleString('en-US', {minimumFractionDigits: 0})} {this.state.moneda}</small>
                                        </div>
                                    </Flex>
                                </div>
                            </Flex>
                        )}


                        <Flex alg={"flex-end"} className="fixed-to-bottom txt-aln-ctn">
                            {!this.state.errorPago && (
                                <Flex className={this.state.url_respuesta.activo ? "col-12 col-md-7 px-0 pb-3 pb-md-0 px-md-0 " : "col-12 col-md-9 px-0 pb-3 pb-md-0 px-md-0 "}>
                                    {!this.state.printState && (
                                        <ShowEmail url_respuesta={this.state.url_respuesta} show={() => this.setState({
                                            email: !this.state.email
                                        })}
                                           email={this.state.email}
                                           loading={this.state.loading}
                                           loadingEmail={this.state.loadingEmail}
                                           downloadPdf={this.downloadPdf.bind(this)}
                                           print={this.print.bind(this)}
                                           onChangeInputText={this.onChangeInputText.bind(this)}
                                           sendEmail={this.sendEmail.bind(this)}
                                           enviado={this.state.enviado}
                                           error={this.validator.message('email', this.state.textEmail, ['required', {regex: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'}])}
                                        />
                                    )}
                                    <a hidden id="pdf"> </a>
                                </Flex>
                            )}

                            {!this.state.printState && (
                                this.state.url_respuesta.activo ? (
                                    <div 
                                        className="col-12 col-md-5 px-0 pb-3 pb-md-0 px-md-0 btn-aln">
                                            <div className="col-12 col-md-6 pb-3 pb-md-0 pl-md-0 btn-bar-font">
                                                <Btn
                                                    className="btn-bar-font"
                                                    classNameBtn="btn-vertical-aln"
                                                    bg 
                                                    onClick={() => this.props.history.push(ruta.home)}
                                                    hg={"45"}
                                                    >
                                                    <img 
                                                        src={require('../../assets/CreditCard.svg')}
                                                        alt="" width={"27px"} height={"auto"} className={"mr-2"}/>
                                                        Pagar otra factura
                                                    </Btn>
                                            </div>
                                            <div className="col-12 col-md-6 pb-3 pb-md-0 pl-md-0 btn-bar-font">
                                                <Btn
                                                    className="btn-bar-font"
                                                    classNameBtn="btn-vertical-aln"
                                                    onClick={() => {
                                                        window.location = this.state.url_respuesta.url;
                                                    }} 
                                                    hg={"45"}>Volver al comercio</Btn>
                                            </div>
                                    </div>
                                ):
                                (
                                    <div className="col-12 col-md-3 px-md-0">
                                        <Btn classNameBtn="btn-vertical-aln" onClick={() => this.props.history.push(ruta.home)} hg={"45"}>Finalizar</Btn>
                                    </div>
                                )
                            )}
                        </Flex>

                    </div>}
                </Mycard>
            </Elastic>
        )
    }


}

export default withRouter(RespuestaOnline);
